import React, { Fragment } from "react"
import styled from 'react-emotion'
import getText from "../strings"
import { Svg } from "../../application"

const Title = styled('h2')`
  font-weight: bold;
  margin-bottom: 20px;
`

const SectionTitle = styled('p')`
  font-weight: bold;
  margin-bottom: 5px;
`
const Flex = styled('div')`
  display: flex;
  margin-bottom: 20px;
`

const Info = styled('div')`
  margin-left: 20px;
`

export default ({ product }) => {
  const { hotelContact, name } = product
  const postalCity = hotelContact.address.postalCode + ' ' + hotelContact.address.city
  return (
    <Fragment>
      <Title>{name}</Title>
      <Flex>
        <Svg icon="phone"></Svg>
        <Info>
          <SectionTitle>{getText('accommodationOnly', 'hotelInfo', 'telephone')}</SectionTitle>
          <p>{hotelContact.phoneNumber || "-" }</p>
        </Info>
      </Flex>
      <Flex>
        <Svg icon="mail"></Svg>
        <Info>
          <SectionTitle>{getText('accommodationOnly', 'hotelInfo', 'email')}</SectionTitle>
          <p>{hotelContact.email || "-"}</p>
        </Info>
      </Flex>
      <Flex>
        <Svg icon="location"></Svg>
        <Info>
          <SectionTitle>{getText('accommodationOnly', 'hotelInfo', 'address')}</SectionTitle>
          <p>{hotelContact.address.street || "-"}</p>
          <p>{hotelContact.address.postalCode || hotelContact.address.city ? postalCity : "-"}</p>
        </Info>
      </Flex>
    </Fragment>
  )
}